import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { AccessEncryption } from "@/features/encryption/components/AccessEncryption";

export function UnlockDB() {
  const navigate = useNavigate();
  const setUser = useBoundStore(useShallow((state) => state.user.set));

  const handleSuccessfulUnlock = useCallback(async () => {
    setUser({ dbLocked: false });
    navigate("/home", { replace: true });
  }, [setUser, navigate]);

  return <AccessEncryption onSuccess={handleSuccessfulUnlock} />;
}
